// extracted by mini-css-extract-plugin
export var cardIcon = "_13-5";
export var cardIconUnframed = "_13-9";
export var checkboxCard = "_13-0";
export var checkboxCardSelected = "_13-4";
export var disabled = "_13-2";
export var interactive = "_13-1";
export var outerBorder = "_13-3";
export var spacerMedium = "_13-8";
export var spacerSmall = "_13-7";
export var spacerXsmall = "_13-6";